module.exports = __webpack_public_path__ + "static/img/tunnel-text-1.5df75e71.png";